var productMixin = {
	data: function () {
		return {
			product: {
				id: GLOBAL.PRODUCT.ID,
			},
			colourMessage: vueProduct_DATA.colourMessage,
			initialPrice: vueProduct_DATA.initialPrice,
			priceResponse: vueProduct_DATA.initialPrice,
			quantity: 1,
			isAvailable: true,
			addToCartButtonDisabled: false,
			price: 0,
			salePrice: 0,
			quantityPrice: 0,
            quantitySalePrice: 0,
            ignoreNextFromPriceChange: false,
			showFromPrice: true,
			isUpdating: false,
			isAddingToCart: false,
			showLimitedStock: false,
			showNonStandard: false,
			showProductRedirect: false,
            showPleaseContactUs: false,
            showAvailableUponRequest: false,
			quoteMe: false
		};
	},
	mixins: [minMaxMixin, disableMixin],
    methods: {
        checkMinMaxForAllProperties() {
            const dimensions = ['width', 'diameter', 'height', 'length', 'tubeDiameter'];
            dimensions.forEach((dimension) => {
                if (document.getElementById(dimension)) {
                    if (document.getElementById(dimension).tagName == 'SELECT') {
                        return;
                    }
                    const minValue = parseInt(document.getElementById(dimension).dataset.min);
                    const maxValue = parseInt(document.getElementById(dimension).dataset.max);
                    this.checkMinMax(dimension, this.product.dimensions[dimension], minValue, maxValue);
                }
            });
        },
        /**
         * Handles the change event for the global product form. 
         * It is triggered when a change is detected within the vueProduct element.
         * It updates the 'showFromPrice' property to false.
         */
        handleGlobalFromPriceChange() {
            if (this.ignoreNextFromPriceChange) {
                this.ignoreNextFromPriceChange = false; // clear after skipping once
                return;
            }

            this.showFromPrice = false;
        },
        /**
         * Forces the display of the "From Price" field.
         * 
         * @param {boolean} [forceChange=true] - Whether to ignore the next "From Price" change event.
         */
        forceShowFromPrice(forceChange = true) {
            this.ignoreNextFromPriceChange = forceChange;
            this.showFromPrice = forceChange;
        },
        /**
         * Checks whether the product is in stock depending on the thickness.
         * The data comes from the thickness object.
         */
        isLimitedOrOutOfStock: function () {
            const vm = this;
            vm.isAvailable = true;
            vm.inStock = true;
            vm.showPleaseContactUs = false;
            vm.showNonStandard = false;
            vm.showLimitedStock = false;
            vm.showAvailableUponRequest = false;

            if (vm.thicknesses.length) {
                let thickness = null;
                switch (vm.productType) {
                    case 'Disc':
                    case 'Sheet':
                    case 'Lettering':
                        thickness = vm.thicknesses.filter(
                            (d) => d.value.toString() === vm.product.dimensions.thickness.toString()
                        )[0];
                        break;
                    case 'Rod':
                        thickness = vm.thicknesses.filter(
                            (d) => d.value.toString() === vm.product.dimensions.diameter.toString()
                        )[0];
                        break;
                    case 'Tube':
                        thickness = vm.thicknesses.filter(
                            (d) => d.value.toString() === vm.product.dimensions.tubeDiameter.toString()
                        )[0];
                        break;
                }

                if (thickness === undefined) {
                    return;
                }

                switch (thickness.status) {
                    case 1: //standard
                        this.forceShowFromPrice(false);
                        break;
                    case 2: //non-standard
                        vm.showNonStandard = true;
                        this.forceShowFromPrice(false);
                        break;
                    case 3: //not available (should be hidden)
                        break;
                    case 4: //out of stock
                        vm.showPleaseContactUs = true;
                        vm.inStock = false;
                        this.forceShowFromPrice(false);
                        break;
                    case 5: //limited stock
                        vm.showLimitedStock = true;
                        vm.inStock = false;
                        this.forceShowFromPrice(false);
                        break;
                    case 6: //redirect
                        vueRedirectProductModal.open(thickness.redirectMeta);
                        vm.isAvailable = false;
                        this.forceShowFromPrice(false);
                        break;
                    case 7: //available on request
                        vm.showAvailableUponRequest = true;
                        vm.isAvailable = false;
                        this.forceShowFromPrice(true);
                        break;
                }
            }
        }
    },
    watch: {
        'product.dimensions.height': function (value) {
            const vm = this;
            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }
            this.checkMinMaxForAllProperties();
            vm.getErrorMessages(value, 'height');
            vm.checkDisabled(value);
        },
        'product.dimensions.width': function (value) {
            const vm = this;
            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }
            this.checkMinMaxForAllProperties();
            vm.getErrorMessages(value, 'width');
            vm.checkDisabled(value);
        },
        'product.dimensions.thickness': function (value) {
            const vm = this;

            vm.getErrorMessages(value, 'select');

            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }

            vm.checkDisabled(value);

            this.updateProductPrice();

            this.checkMinMaxForAllProperties();
        },
        'product.dimensions.tubeDiameter': function (value) {
            const vm = this;
            vm.getErrorMessages(value, 'select');

            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }

            vm.checkDisabled(value);
        },
        'product.dimensions.unit': function (value) {
            const vm = this;
            const dimensions = ['width', 'diameter', 'height', 'length', 'tubeDiameter'];
            dimensions.forEach((dimension) => {
                if (document.getElementById(dimension)) {
                    if (document.getElementById(dimension).tagName == 'SELECT') {
                        return;
                    }
                    const minValue = parseInt(document.getElementById(dimension).dataset.min);
                    const maxValue = parseInt(document.getElementById(dimension).dataset.max);
                    vm.checkMinMax(dimension, vm.product.dimensions[dimension], minValue, maxValue);
                }
            });
        },
        'product.dimensions.diameter': function (value) {
            const vm = this;
            const el = document.getElementById('diameter');

            if (el.type == 'text') {
                this.checkMinMaxForAllProperties();
            } else {
                vm.getErrorMessages(value, 'select');
            }

            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }

            vm.checkDisabled(value);
        },
        'product.dimensions.length': function (value) {
            const vm = this;
            if (document.querySelector('.is-invalid')) {
                vm.requiredFieldsAreValid();
            }
            vm.getErrorMessages(value, 'length');
            vm.checkDisabled(value);
            this.checkMinMaxForAllProperties();
        },
        'product.text': function (value) {
            const vm = this;
            vm.checkCharacters(value);
        },
        'product.edgeFinishing': function (value) {
            //this.requiredFieldsAreValid();
            //this.getErrorMessages(value, 'select');
            //vm.checkDisabled(value);
            //this.updateProductPrice();

            this.globalValidation();
            this.updateProductPrice();
        }
    },
};
